import { refDefined } from './refs';
var NAVIGATE_LEFT_PERCENT = 0.4;
export var navigateNext = function navigateNext(eventX, ref) {
  if (!refDefined(ref)) {
    // if parent element ref not defined - just navigate to next
    return true;
  }

  var _ref$current$getBound = ref.current.getBoundingClientRect(),
      width = _ref$current$getBound.width,
      left = _ref$current$getBound.left;

  return (eventX - left) / width >= NAVIGATE_LEFT_PERCENT;
};